export enum Charts {
    FORMCONVERSION = 'FORMCONVERSION',
    DEVICEANALYTICS = 'DEVICEANALYTICS',
    FORMSTATUS = 'FORMSTATUS',
    ENGAGINGFORMS = 'ENGAGINGFORMS'
  }